import { Card, FormGroup, InputGroup, Overlay } from "@blueprintjs/core";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";

import { AssetDTO } from "../../redux/slices";
import { Button } from "../Button/button";
import styles from "./play-video-overlay.module.scss";

export interface PlayVideoOverlayProps {
  video?: AssetDTO;
  setVideo: (videoSrc: AssetDTO | undefined) => void;
  updateVideo?: (video: AssetDTO) => void;
}

export const PlayVideoOverlay = ({ video, setVideo, updateVideo }: PlayVideoOverlayProps) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false);
  const [title, setTitle] = useState<string>(video?.title || "");
  const [description, setDescription] = useState<string>(video?.description || "");
  const [showActions, setShowActions] = useState<boolean>(false);

  useEffect(() => {
    if (video) {
      setIsOverlayOpen(true);
      setTitle(video.title);
      setDescription(video.description);
    } else {
      setIsOverlayOpen(false);
    }
  }, [video]);

  useEffect(() => {
    // if description or title are different than the video's, show actions
    if (video) {
      if (title !== video.title || description !== video.description) {
        setShowActions(true);
      } else {
        setShowActions(false);
      }
    }
  }, [title, description, video]);

  const handleChangeVideoTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    // update video title
    setTitle(event.target.value);
  };

  const handleChangeVideoDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
    // update video description
    setDescription(event.target.value);
  };

  const handleSaveVideo = () => {
    if (video) {
      const updatedVideo = { ...video, title, description };
      updateVideo?.(updatedVideo);
      setVideo(undefined);
    }
  };

  return (
    <Overlay isOpen={isOverlayOpen} autoFocus transitionDuration={0}>
      <div className={styles.videoContainer} onClick={() => setVideo(undefined)}>
        <ReactPlayer url={video?.url} controls={true} playing />
        <Card className={styles.videoInputCard} onClick={(e) => e.stopPropagation()}>
          <FormGroup label="Video Title">
            <InputGroup fill value={title} onChange={handleChangeVideoTitle} />
          </FormGroup>
          <FormGroup label="Video Description">
            <InputGroup fill value={description} onChange={handleChangeVideoDescription} />
          </FormGroup>

          <div className={styles.actionContainer}>
            <Button intent="danger" onClick={() => setVideo(undefined)}>
              Cancel
            </Button>
            {showActions && (
              <Button intent="primary" onClick={handleSaveVideo} icon="floppy-disk">
                Save Changes
              </Button>
            )}
          </div>
        </Card>
      </div>
    </Overlay>
  );
};
